import Link from 'next/link';
import type React from 'react';

import styles from './FabricError.module.scss';
import { appRoutes } from '@fabric-app/business/app/routing/routes.config';

const FabricError: React.FC<React.PropsWithChildren> = ({ children }) => {
  const reload = () => {
    window.location.href = appRoutes.home;
  };

  return (
    <div className={styles.error}>
      <header>
        <Link href={appRoutes.home} className={styles.dashboard_button} onClick={reload}>
          ← dashboard
        </Link>
      </header>
      <div className={styles.spacer} />
      <div className={styles.error_content}>{children}</div>
      <div className={styles.spacer} />
    </div>
  );
};

export default FabricError;
